"use strict";
function airlineSupplierValidator() {
    return function (control) {
        var airlineControl = control.get('airline');
        var noAirlineControl = control.get('noAirline');
        if (!((airlineControl && airlineControl.value) || (noAirlineControl && noAirlineControl.value))) {
            return { 'required': true };
        }
        return null;
    };
}
exports.airlineSupplierValidator = airlineSupplierValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/airline-supplier.validator.js